<div class="blogListWrap" [@leave] [@enter]>
<app-banner></app-banner>
<app-industry-slider></app-industry-slider>
<app-business-slider></app-business-slider>
</div>